angular.module('ApptBookApp').directive("appointmentBookLoaded", ["appointmentBookGlobalsService", "appointmentBookHelperService",
    "Meevo.Plugins.AppointmentBook.Services.AppointmentBookFilterActionsService", function (globals, helper, filterActions) {
        return {
            restrict: 'A',
            link: function(scope: any, element, attr) {
                globals.scrollContainer = $("#divAppointmentBookScrollContainer");
                globals.scrollContainer.unbind("scroll").bind("scroll", helper.scroll);
                globals.bookContainer = $("#divAppointmentBookContainer");
            }
        }
    }]);